'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('httpSvc', httpSvc);

  httpSvc.$inject = ['$http', '$log', '$q', 'windowSvc', 'msAuth'];

  /* @ngInject */
  function httpSvc($http, $log, $q, windowSvc, msAuth) {
    return {
      get: get,
      post: post,
      put: put,
      patch: patch,
      delete: del
    };

    ////////////////
    /**
     * Call through to $http.get, and on a response we extract res.data. Alert on error
     */
    function get() {
      // IF the URL is defined, but the parameters are not, we add the withCredentials param
      if (angular.isUndefined(arguments[1]) && !angular.isUndefined(arguments[0])) {
        [].push.call(arguments, { withCredentials: true });
      }
      var params = cloneArgs.apply(null, arguments);
      return $http.get.apply(null, arguments).then(function (res) {
        return res.data;
      }, function (err) {
        return error(err, get, params);
      });
    }
    /**
     * Call through to $http.post and write an alert depending on the status
     * @return {[type]} [description]
     */
    function post() {
      // IF the URL is defined, but the parameters are not, we add the withCredentials param
      if (angular.isUndefined(arguments[2]) && !angular.isUndefined(arguments[0])) {
        // If no post data, we need to push undefined first so we can push parameters
        if (angular.isUndefined(arguments[1])) {
          [].push.call(arguments, undefined);
        }
        [].push.call(arguments, { withCredentials: true });
      }
      var params = cloneArgs.apply(null, arguments);
      return $http.post.apply(null, arguments).then(function (res) {
        return res.data;
      }, function (err) {
        return error(err, post, params);
      });
    }

    /**
     * Call through to $http.put and write an alert depending on the status
     * @return {[type]} [description]
     */
    function put() {
      // IF the URL is defined, but the parameters are not, we add the withCredentials param
      if (angular.isUndefined(arguments[2]) && !angular.isUndefined(arguments[0])) {
        // If no post data, we need to push undefined first so we can push parameters
        if (angular.isUndefined(arguments[1])) {
          [].push.call(arguments, undefined);
        }
        [].push.call(arguments, { withCredentials: true });
      }
      var params = cloneArgs.apply(null, arguments);
      return $http.put.apply(null, arguments).then(function (res) {
        return res.data;
      }, function (err) {
        return error(err, put, params);
      });
    }
    /**
     * Call through to $http.patch and write an alert depending on the status
     * Based on post method
     * @return {[type]} [description]
     */
    function patch() {
      // IF the URL is defined, but the parameters are not, we add the withCredentials param
      if (angular.isUndefined(arguments[2]) && !angular.isUndefined(arguments[0])) {
        // If no patch data, we need to push undefined first so we can push parameters
        if (angular.isUndefined(arguments[1])) {
          [].push.call(arguments, undefined);
        }
        [].push.call(arguments, { withCredentials: true });
      }
      var params = cloneArgs.apply(null, arguments);
      return $http.patch.apply(null, arguments).then(function (res) {
        return res.data;
      }, function (err) {
        return error(err, patch, params);
      });
    }
    /**
     * call through to the $http delete function
     */
    function del() {
      // IF the URL is defined, but the parameters are not, we add the withCredentials param
      if (angular.isUndefined(arguments[1]) && !angular.isUndefined(arguments[0])) {
        [].push.call(arguments, { withCredentials: true });
      }
      var params = cloneArgs.apply(null, arguments);
      return $http.delete.apply(null, arguments).then(function () {}, function (err) {
        return error(err, del, params);
      });
    }

    /**
     * clone the arguments into an array for spreadability in replays
     */
    function cloneArgs() {
      var params = [];
      if (!angular.isUndefined(arguments[0])) [].push.call(params, arguments[0]);
      if (!angular.isUndefined(arguments[1])) [].push.call(params, arguments[1]);
      if (!angular.isUndefined(arguments[2])) [].push.call(params, arguments[2]);
      return params;
    }

    /**
     * Generic error handler
     */
    function error(err, fn, params) {
      if (err.status === 401 && err.data.errorCode && (err.data.errorCode === 'TOKEN_EXPIRED' || err.data.errorCode === 'NO_TOKEN')) {
        if (msAuth.hasReauthCookie()) {
          return msAuth.reauth(moment.tz.guess()).then(function () {
            //recurse and try again
            return fn.apply(null, params);
          });
        } else {
          var _redirect = windowSvc.getRedirectUrl();
          $log.debug('httpSvc-error: User is not logged in - redirecting to login page with ' + _redirect);
          windowSvc.windowNavigate('/login/?redirecturl=' + _redirect);
        }
      }
      //always reject if we didn't hit the retry case - the reject will be ignored in a windowNavigate scenario (401)
      return $q.reject(err);
    }
  }
})();